// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M743","header":"styles_header__tFk-x","content":"styles_content__2n6rL","footer":"styles_footer__2Udmy"};